import FashionProducts from './FashionProducts'

function FashionOffers() {
  return <FashionProducts offersOnly />
}

export default FashionOffers

